import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { Route } from 'react-router-dom';
import { COOKIES } from '../../../_shared/constants/cookies';
import ReducerConstants from '../../../_shared/constants/reducers';
import SystemConfigService from '../../../services/SystemConfigService';
import EncryptionService from '../../../services/EncryptionService';
import { getCookie } from '../../../_shared/utils/cookies';

const RouteExternal = props => {
  const { link, computedMatch, location, ...routeProps } = props;
  const configurations = useSelector(
    state => state[ReducerConstants.AUTH]?.system?.configurations,
    shallowEqual
  );

  const systemConfigService = SystemConfigService.get(configurations);
  const sharedKey = systemConfigService.getSSOSharedKey();
  const accessToken = getCookie(COOKIES.AUTH_TOKEN);
  const encryptedKey = EncryptionService.encryptDecrypt(accessToken, sharedKey);
  const host = process.env.REACT_APP_SWAGGER_URL;

  return (
    <Route
      {...routeProps}
      render={() => {
        // If clicking on a profile or Q&A link
        if (link?.includes('profile')) {
          let newLink = link;

          if (link.includes(':profileId')) {
            newLink = newLink.replace(
              ':profileId?',
              computedMatch.params.profileId
            );
          }

          if (link.includes(':dealerId?')) {
            newLink = newLink.replace(
              ':dealerId?',
              computedMatch.params.dealerId
            );
          }

          window.location.replace(newLink);
        } else if (link.includes('/qa')) {
          const newLink = link.replace(
            ':tradeId?',
            computedMatch.params.tradeId
          );

          window.location.replace(newLink);
        } else if (link.includes('/research')) {
          let newLink = link;

          if (location.search) {
            newLink += location.search;
          }

          window.location.replace(newLink);
        } else if (location?.pathname?.includes('support')) {
          // If clicking on the support link
          const { pathname } = location;

          window.location.replace(
            `${host}/auth/salesforce${pathname}?token=${encodeURIComponent(
              encryptedKey
            )}`
          );
        } else if (link.includes('/accounting')) {
          window.location.replace(`${link}${computedMatch.params.page}`);
        } else if (link.includes('/reports')) {
          window.location.replace(`${link}${computedMatch.params.context}`);
        } else {
          window.location.replace(link);
        }
        return null;
      }}
    />
  );
};

export default RouteExternal;
